import { Form } from "antd";
import { useLocation, useParams } from "react-router";

import type { ProductProfileProductEntity } from "src/app/features/ProductProfile/types/subTypes/ProductProfileProductEntity";
import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { OrgUnitsProductsProfile } from "./OrgUnitsProductsProfile";

export const OrgUnitsProductsProfileField: FieldMethod = ({ field, readOnly }: FormFieldFactoryProps) => {
    const { id } = useParams();
    const location = useLocation();
    const showForceValue = location.pathname.includes("/site-groups");

    return (
        <Form.Item
            noStyle
            shouldUpdate={(prev, curr) =>
                prev[field.name] !== curr[field.name] ||
                prev.childProductProfileId !== curr.childProductProfileId ||
                prev.parentUnit !== curr.parentUnit ||
                prev.productProfileId !== curr.productProfileId
            }
        >
            {({ getFieldValue }) => (
                <Form.Item key={`${field.name}FormItem`} name={field.name}>
                    <OrgUnitsProductsProfile
                        key={`${field.name}-${id}`}
                        readOnly={readOnly}
                        showForceValue={showForceValue}
                        value={getFieldValue(field.name) as ProductProfileProductEntity[]}
                        onChange={(data) => data}
                    />
                </Form.Item>
            )}
        </Form.Item>
    );
};
